module.exports = __webpack_public_path__ + "img/drop.5f7b7b35.png";